<template>
    <transition name="modal-animation">
        <div v-show="modalActive" class="quanty-modal" @click.self="closeModal">
            <transition name="modal-animation-inner">
                <div v-show="modalActive" class="quanty-modal-inner">
                    <i @click="closeModal" class="far fa-times-circle"></i>
                    <!-- Modal content -->
                    <slot />
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>
export default {
    props: ["modalActive"],
    setup(props, { emit }) {
        const close = () => {
            emit("cerrar-modal");
        };
        return { close };
    },
    methods: {
        closeModal() {
        // Emitir un evento para llamar a la función en la vista superior
        this.$emit('cerrar-modal');
        }
    }
}
</script>

<style lang="scss" scoped>

/* ============================
   ANIMACIONES DE APERTURA
============================ */
.modal-animation-enter-active,
.modal-animation-leave-active {
  transition: opacity 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02);
}
.modal-animation-enter-from,
.modal-animation-leave-to {
  opacity: 0;
}

.modal-animation-inner-enter-active {
  transition: all 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02) 0.15s;
}
.modal-animation-inner-leave-active {
  transition: all 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02);
}
.modal-animation-inner-enter-from {
  opacity: 0;
  transform: scale(0.92);
}
.modal-animation-inner-leave-to {
  transform: scale(0.92);
}

/* ============================
   OVERLAY DEL MODAL
============================ */
.quanty-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;

  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);

  display: flex;
  justify-content: center;
  align-items: center;

  overflow-y: auto;
  padding: 1rem;
  -webkit-overflow-scrolling: touch;

  pointer-events: auto;
}

/* ============================
   MODAL INTERNO (ESCRITORIO)
============================ */
.quanty-modal-inner {
  width: 600px;
  max-width: 90%;

  background: var(--q-card);
  border-radius: 1rem;
  padding: 2rem;

  position: relative;
  overflow: visible;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);

  pointer-events: auto;
  z-index: 100000; /* asegura que esté por encima del overlay en móviles */
}

/* BOTÓN CERRAR */
.quanty-modal-inner i {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 22px;
  cursor: pointer;
  z-index: 100001;
  pointer-events: auto;
}
.quanty-modal-inner i:hover {
  color: var(--q-red);
}

/* =====================================================
   📱 TABLET / MÓVIL GRANDE (480–767px)
===================================================== */
@media (max-width: 767px) {
  .quanty-modal {
    align-items: flex-start;
    padding-top: 2rem;
  }

  .quanty-modal-inner {
    width: 95% !important;
    max-width: 95% !important;
    border-radius: 0.8rem !important;
    margin-top: 0 !important;
  }
}

/* =====================================================
   📱 FULLSCREEN EN MÓVIL PEQUEÑO (≤ 480px)
===================================================== */
@media (max-width: 480px) {
  .quanty-modal {
    padding: 0 !important;
    align-items: flex-start !important;
  }

  .quanty-modal-inner {
    width: 100vw !important;

    height: auto !important;
    max-height: 100% !important;

    min-height: 100dvh !important;

    max-width: 100vw !important;

    border-radius: 0 !important;
    margin: 0 !important;

    padding: 1.2rem !important;
    overflow-y: auto !important;
  }
}
</style>
